import moment from 'moment';
import reportDao from '../../../../dao/reportDao';
import _isUndefined from 'lodash/isUndefined';
import {exampleData} from './components/exampleData';
import accountDao from '../../../../dao/accountDao';

const LOAD = 'pages/webmodule/reports/impressions/LOAD';
const LOAD_SUCCESS = 'pages/webmodule/reports/impressions/LOAD_SUCCESS';
const CHANGE_DATE_RANGE =
  'pages/webmodule/reports/impressions/CHANGE_DATE_RANGE';
const CHANGE_TIME_PERIOD =
  'pages/webmodule/reports/impressions/CHANGE_TIME_PERIOD';
const LOAD_EXAMPLE = 'pages/webmodule/reports/impressions/LOAD_EXAMPLE';
const SET_REPORT_VIEWED =
  'pages/webmodule/reports/impressions/SET_REPORT_VIEWED';

const initialState = {
  impressions: {data: {}, loaded: false, loading: false},
  since: moment().subtract(6, 'month'),
  until: moment(),
  timePeriod: 'week',
  isExampleData: false,
  reportViewed: false,
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      const newState1 = {...state};
      newState1[action.dataType].loading = true;
      newState1.isExampleData = false;
      return newState1;
    case LOAD_SUCCESS:
      const newState2 = {...state};
      newState2[action.dataType].loaded = true;
      newState2[action.dataType].data = action.result;
      return newState2;
    case CHANGE_DATE_RANGE:
      return {
        ...state,
        impressions: {data: {}, loaded: false, loading: false},
        since: action.since,
        until: action.until,
      };
    case CHANGE_TIME_PERIOD:
      return {
        ...state,
        impressions: {data: {}, loaded: false, loading: false},
        timePeriod: action.timePeriod,
      };
    case LOAD_EXAMPLE:
      const newState3 = {...state};
      const data = exampleData();
      newState3.impressions.data = data.impressions.response;
      newState3.since = moment(data.impressions.request.begin);
      newState3.until = moment(data.impressions.request.end);
      newState3.timePeriod = data.impressions.request.granularity;
      newState3.isExampleData = true;
      return newState3;
    case SET_REPORT_VIEWED:
      return {
        ...state,
        reportViewed: action.reportViewed,
      };
    default:
      return state;
  }
}

function load(dataType) {
  return {
    type: LOAD,
    dataType,
  };
}

function loadAsync(dataType) {
  return (dispatch, getState) => {
    dispatch(load(dataType));

    const params = {
      reportType: 'IMPRESSIONS',
      begin: getState().pages.webmodule.reports.impressions.since.format(
        'YYYY-MM-DD'
      ),
      end: getState().pages.webmodule.reports.impressions.until.format(
        'YYYY-MM-DD'
      ),
      granularity: getState().pages.webmodule.reports.impressions.timePeriod,
    };
    accountDao.queryEngagement().then(r => {
      dispatch(setReportViewed(r.reportViewed));
    });
    reportDao.listReport(params).then(json => {
      dispatch(loadSuccess(dataType, json));
      dispatch(loadExampleIfNeeded());
    });
  };
}

function loadExample() {
  return {
    type: LOAD_EXAMPLE,
  };
}

function loadExampleIfNeeded() {
  return (dispatch, getState) => {
    const impressions = getState().pages.webmodule.reports.impressions
      .impressions;
    const isReportViewed = getState().pages.webmodule.reports.impressions
      .reportViewed;
    const shouldLoadExample =
      !isReportViewed &&
      (impressions.loaded &&
        (_isUndefined(impressions.data.valid) ||
          !impressions.data.valid.length));
    if (shouldLoadExample) {
      dispatch(loadExample());
    }
  };
}

function loadSuccess(dataType, result) {
  return {
    type: LOAD_SUCCESS,
    dataType,
    result,
  };
}

function shouldLoad(state, dataType) {
  const s = state.pages.webmodule.reports.impressions[dataType];
  if (s.loaded) {
    return false;
  }
  if (s.loading) {
    return false;
  }
  return true;
}

export function loadIfNeeded(dataType) {
  return (dispatch, getState) => {
    if (shouldLoad(getState(), dataType)) {
      return dispatch(loadAsync(dataType));
    }
  };
}

export function changeDateRange(since, until) {
  return {
    type: CHANGE_DATE_RANGE,
    since,
    until,
  };
}

export function changeTimePeriod(timePeriod) {
  return {
    type: CHANGE_TIME_PERIOD,
    timePeriod,
  };
}

export function setReportViewed(reportViewed) {
  return {
    type: SET_REPORT_VIEWED,
    reportViewed,
  };
}
